import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../store';
import { FlowStage } from '../store/flow';
import { messageService } from '../service/messageService';

const { MultiStepTracker, Step } = require('@americanexpress/dls-react');

const MultiStepTrackerWrapper = (props:any) => {
  const { t } = useTranslation();
  const { initialStage, stage } = useAppSelector((state) => state.flow);

  const stepOrder = [initialStage, FlowStage.UserInformation, FlowStage.CompanyInformation];
  const stepOrderOneId = [FlowStage.UserInformation, FlowStage.CompanyInformation];
  const [displayTracker, setdisplayTracker] = useState(true);
  const currentStepIndex = stepOrder.indexOf(stage);
  const currentStepIndexOneId = stepOrderOneId.indexOf(stage);

  useEffect(() => {
     messageService.getstepperToggle().subscribe((res:any)=>{
      setdisplayTracker(res);
     })
  }, []); 


  return (
    <div>
    { (displayTracker === true && !props.oneIdentityEnabled)
        && (
    <MultiStepTracker currentStep={props.greyOut ? 0 : currentStepIndex + 1}>
      {stepOrder.map((step) => (
        <Step key={step} label={t(`multi_step_tracker.${FlowStage[step].toLowerCase()}`)} />
      ))}
    </MultiStepTracker>
    )}
    { (displayTracker === true && props.oneIdentityEnabled)
        && (
    <MultiStepTracker currentStep={props.greyOut ? 0 : currentStepIndexOneId + 1}>
      {stepOrderOneId.map((step) => (
        <Step key={step} label={t(`multi_step_tracker.${FlowStage[step].toLowerCase()}`)} />
      ))}
    </MultiStepTracker>
    )}
    </div>
  );
};

export default MultiStepTrackerWrapper;
